// Accounts
import Accounts from './account-pages/accounts-page/accounts.page.vue';
import InactiveAccounts from './account-pages/inactive-accounts-page/inactive-accounts.page.vue';
import Account from './account-pages/account-page/account.page.vue';
import Activity from './account-pages/account-child-pages/activity.page.vue';
import Claims from './account-pages/account-child-pages/claims.page.vue';
import Eligibility from './account-pages/account-child-pages/eligibility.page.vue';
import ManageAccount from './account-pages/account-child-pages/manage-account.page.vue';
import AccountOverview from './account-pages/account-child-pages/account-overview.page.vue';
import Statements from './account-pages/account-child-pages/statements.page.vue';
import TaxForms from './account-pages/account-child-pages/tax-forms.page.vue';

// Account Settings
import AccountSettings from './account-settings-pages/account-settings.page.vue';
import AccountSettingsOverview from './account-settings-pages/account-settings-overview.page.vue';

// Beneficiaries
import Beneficiaries from './beneficiaries-pages/beneficiaries.page.vue';

// Contact Us
import ContactUs from './contact-us-page/contact-us.page.vue';

// Login
import Login from './login-page/login.page.vue';

// Register
import Register from './register-page/register.page.vue';

// Logged Out
import LoggedOut from './logged-out-page/logged-out.page.vue';

// Notifications
import Notifications from './notifications-page/notifications.page.vue';

// PageWrapper
import PageWrapper from './page-wrapper/page-wrapper.component.vue';

//SelectGroup
import SelectGroup from './multiple-groups-page/multiple-group-select.page.vue';

// Payment & Banking
import PaymentAndBanking from './payment-and-banking-pages/payment-and-banking.page.vue';
import PaymentMethod from './payment-and-banking-pages/payment-and-banking-child-pages/payment-method.page.vue';
import BankAccounts from './payment-and-banking-pages/payment-and-banking-child-pages/bank-accounts.page.vue';

// Personal Information
import PersonalInformation from './personal-information-page/personal-information.page.vue';

// Providers
import Providers from './providers-page/providers.page.vue';

// Release Authorizations
import ReleaseAuthorizations from './release-authorizations-page/release-authorizations.page.vue';

// Resources
import Resources from './resource-pages/resources.page.vue';

// Root
import Root from './root-component/root.component.vue';

// Communications
import Communications from './communications-page/communications.page.vue';

// SSO Error
import SSOError from './error-page/sso-error.page';

// My Documents
import MyDocuments from './my-documents-pages/my-documents.page.vue';
import DocumentDetail from './my-documents-pages/document-detail.page.vue';

// Substantiate Claims
import SubstantiateClaims from './substantiate-claims-page/substantiate-claims.page.vue';

// Loading Page
import LoadingPage from './loading-page/loading.page.vue';

// Federated Logged Out
import FederatedLogOut from './federated-log-out/federated-log-out.page.vue';

// Interest Rates Page
import InterestRates from './interest-rates-page/interest-rates.page.vue';

// Get SA ID Page
import GetSaId from './get-sa-id-page/get-sa-id.page.vue';

// Federate HQY Page
import FederateHQY from './federate-hqy/federate-hqy-page.vue';

export {
  SSOError,
  Accounts,
  InactiveAccounts,
  Account,
  Activity,
  Claims,
  Eligibility,
  ManageAccount,
  AccountOverview,
  Statements,
  TaxForms,
  AccountSettings,
  AccountSettingsOverview,
  Beneficiaries,
  ContactUs,
  Login,
  Register,
  Notifications,
  PageWrapper,
  PaymentAndBanking,
  PaymentMethod,
  BankAccounts,
  PersonalInformation,
  Providers,
  ReleaseAuthorizations,
  Resources,
  Root,
  Communications,
  MyDocuments,
  DocumentDetail,
  LoggedOut,
  SelectGroup,
  SubstantiateClaims,
  LoadingPage,
  FederatedLogOut,
  InterestRates,
  GetSaId,
  FederateHQY
};
